import { UserLoginState } from "../reducers/LoginReducer";
import { Common } from "./Common";

function getAuthHeaderTocken() {
    let logUser = Common.getLoginUserData();
    if(logUser && logUser !== null){
        let user: UserLoginState = JSON.parse(logUser);
        return user.accessToken;
    }
    return "";
}

function getRefreshToken() {
    let logUser = Common.getLoginUserData();
    if(logUser && logUser !== null){
        let user: UserLoginState = JSON.parse(logUser);
        return user.refreshToken;
    }
    return "";
}


export const AuthUtil = {
    getAuthHeaderTocken,
    getRefreshToken
};